// bb-home-logos.js -- extraído de rgd-image-logo-slider.liquid (script original 694-929) no
// Lote 5. É o carrossel nativo à mão gêmeo do de featured-collection (achado #41): drag por
// mousedown/mousemove, dots criados com createElement. Não é reescrito aqui -- a unificação
// dos dois fica registrada no fechamento, porque juntar os dois é redesenho, não extração.
//
// O arquivo virou asset estático: não há mais {{ section.id }} para nomear a função por
// instância, então cada seção na página é achada por [data-rgd-image-logo-slider-track] e
// inicializada por si. cards_per_view/cards_per_view_mobile chegam por data-attribute.
//
// Os listeners de mousemove/mouseup/blur eram registrados em document/window e sobreviviam
// à seção -- no editor de temas a seção é trocada sem recarregar a página. Cada instância
// guarda os que registrou em `registrados` (chave = wrapper #shopify-section-*) e o
// shopify:section:unload os remove.
(() => {
  const registrados = new Map(); // wrapper da seção -> [[alvo, evento, handler], ...]

  const secaoDe = (el) => el.closest('[id^="shopify-section-"]') || el;

  const registra = (wrapper, alvo, evento, handler, opcoes) => {
    alvo.addEventListener(evento, handler, opcoes);
    if (!registrados.has(wrapper)) registrados.set(wrapper, []);
    registrados.get(wrapper).push([alvo, evento, handler]);
  };

  const initOne = (slider) => {
    const dotsWrap = slider.closest('.rgd-image-logo-slider__slider')?.querySelector('[data-rgd-carousel-dots]');
    if (!dotsWrap) return;

    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const getCardsPerView = () => {
      return isDesktop()
        ? Number(slider.dataset.cardsPerView) || 1
        : Number(slider.dataset.cardsPerViewMobile) || 1;
    };

    const getRealItems = () => {
      return Array.from(slider.children).filter((item) => {
        return item.classList.contains('rgd-image-logo-slider__item') && window.getComputedStyle(item).display !== 'none';
      });
    };

    const getGap = () => {
      const styles = window.getComputedStyle(slider);
      return parseFloat(styles.columnGap || styles.gap || 0) || 0;
    };

    const getItemStep = () => {
      const firstItem = getRealItems()[0];
      if (!firstItem) return 0;
      return firstItem.getBoundingClientRect().width + getGap();
    };

    const getMaxScroll = () => {
      return Math.max(slider.scrollWidth - slider.clientWidth, 0);
    };

    const getPageStep = () => {
      return getItemStep() * getCardsPerView();
    };

    const getPageCount = () => {
      const total = getRealItems().length;
      const perView = getCardsPerView();

      if (!isDesktop() || !total || total <= perView || getMaxScroll() <= 2) return 0;

      return Math.ceil(total / perView);
    };

    const getPageAnchors = () => {
      const pageCount = getPageCount();
      const maxScroll = getMaxScroll();
      const pageStep = getPageStep();

      if (pageCount <= 1 || !pageStep) return [];

      return Array.from({ length: pageCount }, (_, index) => {
        if (index === pageCount - 1) return maxScroll;
        return Math.min(pageStep * index, maxScroll);
      });
    };

    const getClosestAnchorIndex = () => {
      const anchors = getPageAnchors();
      if (!anchors.length) return 0;

      let closestIndex = 0;
      let closestDistance = Infinity;

      anchors.forEach((left, index) => {
        const distance = Math.abs(slider.scrollLeft - left);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const updateDots = () => {
      const dots = Array.from(dotsWrap.querySelectorAll('[data-rgd-carousel-dot]'));
      if (!dots.length) return;

      const activeIndex = getClosestAnchorIndex();

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const buildDots = () => {
      const pageCount = getPageCount();
      dotsWrap.innerHTML = '';

      if (pageCount <= 1) {
        dotsWrap.hidden = true;
        return;
      }

      dotsWrap.hidden = false;

      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = `rgd-carousel-dot${index === 0 ? ' is-active' : ''}`;
        dot.dataset.rgdCarouselDot = '';
        dot.dataset.rgdIndex = String(index);
        dot.setAttribute('aria-label', `Ir para página ${index + 1}`);
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');

        dot.addEventListener('click', () => {
          const anchors = getPageAnchors();
          const left = anchors[index] || 0;

          slider.scrollTo({
            left,
            behavior: 'smooth'
          });

          dotsWrap.querySelectorAll('[data-rgd-carousel-dot]').forEach((item, itemIndex) => {
            const isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        });

        dotsWrap.appendChild(dot);
      }

      updateDots();
    };

    const initDragScroll = () => {
      if (slider.dataset.rgdDragReady === 'true') return;
      slider.dataset.rgdDragReady = 'true';

      const wrapper = secaoDe(slider);

      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;
      let rafId = null;

      const canDrag = () => {
        return isDesktop() && slider.scrollWidth > slider.clientWidth + 2;
      };

      const requestDotUpdate = () => {
        if (rafId) return;

        rafId = window.requestAnimationFrame(() => {
          updateDots();
          rafId = null;
        });
      };

      const start = (event) => {
        if (!canDrag()) return;
        if (event.button !== 0) return;

        isDragging = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;

        slider.classList.add('is-dragging');
        document.documentElement.classList.add('rgd-carousel-page-dragging');

        event.preventDefault();
      };

      const move = (event) => {
        if (!isDragging) return;

        const distance = event.clientX - startX;
        if (Math.abs(distance) > 2) moved = true;

        slider.scrollLeft = startScrollLeft - distance;
        requestDotUpdate();
        event.preventDefault();
      };

      const end = () => {
        if (!isDragging) return;

        isDragging = false;
        slider.classList.remove('is-dragging');
        document.documentElement.classList.remove('rgd-carousel-page-dragging');

        if (moved) {
          slider.dataset.rgdJustDragged = 'true';

          window.setTimeout(() => {
            slider.dataset.rgdJustDragged = 'false';
          }, 180);
        }

        updateDots();
      };

      slider.addEventListener('mousedown', start);
      registra(wrapper, document, 'mousemove', move, { passive: false });
      registra(wrapper, document, 'mouseup', end);
      registra(wrapper, window, 'blur', end);

      slider.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      slider.addEventListener('click', (event) => {
        if (slider.dataset.rgdJustDragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      slider.addEventListener('scroll', requestDotUpdate, { passive: true });
    };

    buildDots();
    initDragScroll();
    updateDots();
  };

  const varrer = (raiz) => {
    (raiz || document).querySelectorAll('[data-rgd-image-logo-slider-track]').forEach(initOne);
  };

  document.addEventListener('DOMContentLoaded', () => varrer(document));
  document.addEventListener('shopify:section:load', (event) => varrer(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    (registrados.get(event.target) || []).forEach(([alvo, evento, handler]) => alvo.removeEventListener(evento, handler));
    registrados.delete(event.target);
  });
  window.addEventListener('resize', () => {
    window.requestAnimationFrame(() => varrer(document));
  });
})();
